export default {"src":"/_next/static/media/custom-req.9b71653a.svg","height":406,"width":411};